import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Latest from '../components/Latest';
import AppTheme from '../AppTheme';
import { Helmet } from 'react-helmet-async';

export default function NewsPage(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {/* 移除這裡的 AppAppBar，因為 Latest 組件裡已經有了 */}
      {/* <AppAppBar /> */}
      <Container
        maxWidth="lg"
        component="main"
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          // 調整邊距，因為 Latest 組件已經處理了頂部間距
          my: 0, // 改為 0，讓 Latest 組件控制間距
          gap: 4,
          // 確保容器可以滾動
          overflow: 'visible',
        }}
      >
        <Helmet>
          <title>最新全球財經新聞與動態</title>
          <meta name="description" content="即時追蹤全球宏觀經濟、市場動態與機構發文，提供中英雙語對照與專業解析。" />
          <link rel="canonical" href="https://yourdomain.com/news" />
          
          {/* Open Graph / 社群分享標籤 */}
          <meta property="og:title" content="最新全球財經新聞與動態" />
          <meta property="og:description" content="即時追蹤全球宏觀經濟、市場動態與機構發文。" />
          <meta property="og:type" content="website" />
        </Helmet>
        <Latest />
      </Container>
    </AppTheme>
  );
}